module.exports = __webpack_public_path__ + "img/teamAvatar.e8e9d4d8.png";